import React, { useMemo } from 'react';
import clsx from 'clsx';
import Accordion from '../Accordion';
import Button from '../Button';
import styles from './LettingIncomeTotals.module.scss';
import { getFormattedForecastPrice } from '../LettingPricingTable/utils';
const buildTotalBreakCost = (totals) => {
    var _a, _b, _c;
    const total = (((_a = totals.frozen) === null || _a === void 0 ? void 0 : _a.value) || 0) + (((_b = totals.pending) === null || _b === void 0 ? void 0 : _b.value) || 0) + (((_c = totals.potential) === null || _c === void 0 ? void 0 : _c.value) || 0);
    return getFormattedForecastPrice(total);
};
export const LettingIncomeTotals = ({ totals, onHelpCtaClick, totalBreakCount, compressed = false, accordionTitle = 'How are totals calculated?', accordionSubtext = 'The break values for Fixed are based on guest booking history and risk.', showCta = true, onFindOutMoreClick, }) => {
    var _a, _b;
    const totalBreakCost = useMemo(() => buildTotalBreakCost(totals), [totals]);
    return (<div className={clsx(styles.incomeTotals, compressed && styles.compressed)}>
      <div className={styles.header}>
        <h3 className={styles.total}>
          Total confirmed income ({(_a = totals === null || totals === void 0 ? void 0 : totals.frozen) === null || _a === void 0 ? void 0 : _a.breakCount} breaks):{' '}
          <span>{getFormattedForecastPrice(((_b = totals === null || totals === void 0 ? void 0 : totals.frozen) === null || _b === void 0 ? void 0 : _b.value) || 0)}</span>
        </h3>
        <p>
          Of future Haven Letting earning potential from
          <span>
            {totalBreakCount} breaks submitted of {totalBreakCost}
          </span>
        </p>
      </div>
      <div className={styles.incomeBody}>
        {compressed && showCta && onFindOutMoreClick && (<Button includeChevron className={styles.incomeCta} onClick={() => onFindOutMoreClick()} data-testid='letting-income-cta'>
            See full lettings income
          </Button>)}
        <div className={styles.infoSection}>
          <Accordion buttonText={accordionTitle} accordionText={accordionSubtext}/>
          <Button className={styles.helpCta} data-testid='help-button' variant='outlined' onClick={() => onHelpCtaClick()}>
            Help
          </Button>
        </div>
      </div>
    </div>);
};
